<div class="share-products" fxLayout="column">

  <!-- /Products list -->
  <div>
    <kl-store-products-list [storeType]="storeType" (selectedProducts)="submitShareProducts($event)"></kl-store-products-list>
  </div>
  <!-- /Products list -->
</div>
